import { makeStyles } from '@material-ui/core/styles'
import {
  OUTLINED_INPUT_BORDER,
  OUTLINED_INPUT_BORDER_RADIUS,
} from 'lib/form-field-styles'

export {
  OUTLINED_INPUT_BORDER as EDIT_EVENT_INPUT_BORDER,
  OUTLINED_INPUT_BORDER_RADIUS as EDIT_EVENT_INPUT_BORDER_RADIUS,
} from 'lib/form-field-styles'

export const useStyles = makeStyles(theme => ({
  loadingStyles: {
    zIndex: 1000,
    position: 'sticky',
    top: '69px',
  },
  actionBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: theme.spacing(2, 4),
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.common.white,
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2, 2),
    },
  },
  cancelAction: {
    textTransform: 'none',
    fontWeight: 600,
    color: '#172024',
    paddingLeft: 0,
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '& .MuiButton-startIcon': {
      marginRight: theme.spacing(0.5),
      marginLeft: 0,
    },
  },
  saveAction: {
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 24,
    padding: theme.spacing(1, 2.5),
    minWidth: 'auto',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
    '& .MuiButton-endIcon': {
      marginLeft: theme.spacing(0.5),
      marginRight: 0,
    },
    '& .MuiButton-startIcon': {
      marginRight: theme.spacing(0.5),
      marginLeft: 0,
    },
  },
  layoutGrid: {
    display: 'grid',
    gridTemplateColumns: '200px minmax(0, 1fr)',
    alignItems: 'start',
    gap: theme.spacing(4),
    width: '100%',
    paddingLeft: theme.spacing(6),
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      paddingLeft: 0,
    },
  },
  navColumn: {
    width: '200px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  formColumn: {
    minWidth: 0,
    maxWidth: 720,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  },
  fieldGroup: {
    marginBottom: theme.spacing(3),
    width: '100%',
  },
  pageTitle: {
    fontSize: '1.5rem',
    fontWeight: 400,
    color: theme.palette.text.primary,
    lineHeight: 1.3,
    marginBottom: theme.spacing(3),
  },
  sectionHeading: {
    fontSize: '1rem',
    fontWeight: 400,
    color: theme.palette.text.primary,
    lineHeight: 1.3,
    marginBottom: theme.spacing(2),
  },
  fieldHelper: {
    fontSize: '0.8125rem',
    fontWeight: 400,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
    lineHeight: 1.5,
  },
  requiredMark: {
    color: '#172024',
  },
  fieldInput: {
    maxWidth: '100%',
    width: '100%',
    marginBottom: 0,
    marginTop: theme.spacing(0.5),
  },
  fieldControlAfterHeading: {
    marginTop: theme.spacing(1),
  },
  outlinedButton: {
    borderRadius: OUTLINED_INPUT_BORDER_RADIUS,
    fontWeight: 600,
    letterSpacing: '0.04em',
  },
  editorRoot: {
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    minHeight: 280,
    border: `1px solid ${OUTLINED_INPUT_BORDER}`,
    borderRadius: OUTLINED_INPUT_BORDER_RADIUS,
    padding: '0 16px',
    overflow: 'hidden',
    '& > div': {
      width: '100%',
      maxWidth: '100%',
    },
  },
  editor: {
    minHeight: 220,
  },
  cancelSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(2.5, 3),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(4),
    borderRadius: 12,
    border: '1px solid #F5C6C6',
    backgroundColor: '#FEF6F6',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  cancelContent: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    minWidth: 0,
    [theme.breakpoints.down('sm')]: {
      alignSelf: 'stretch',
      alignItems: 'flex-start',
    },
  },
  cancelSectionAction: {
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'center',
    flexShrink: 0,
    '& > div': {
      marginBottom: 0,
    },
  },
  cancelIconCircle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
    borderRadius: '50%',
    backgroundColor: '#FCE8E8',
    flexShrink: 0,
  },
  cancelIcon: {
    color: theme.palette.error.main,
  },
  cancelTitle: {
    fontSize: '0.9375rem',
    fontWeight: 600,
    color: '#172024',
    marginBottom: theme.spacing(0.25),
  },
  cancelDescription: {
    fontSize: '0.8125rem',
    color: theme.palette.text.secondary,
    lineHeight: 1.5,
  },
  cancelButton: {
    borderColor: theme.palette.error.main,
    color: theme.palette.error.main,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    borderRadius: 8,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    '&:hover': {
      borderColor: theme.palette.error.dark,
      backgroundColor: 'rgba(211, 47, 47, 0.04)',
    },
  },
}))
